import script from "./StoreInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreInfo.vue?vue&type=script&setup=true&lang=js"

import "./StoreInfo.vue?vue&type=style&index=0&id=2fcf9571&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fcf9571"]])

export default __exports__